import React from 'react'
import { Slice } from 'gatsby'
import { SliceZone } from '@prismicio/react'

// Components
const Collection = React.lazy(() => import('./collection'))

const components = {
  accordion: ({ slice }) => <Slice allowEmpty alias='accordion' slice={slice} />,
  banner_with_caption: ({ slice }) => <Slice allowEmpty alias='bannerWithCaption' slice={slice} />,
  blogposts: ({ slice }) => <Slice allowEmpty alias='blogposts' slice={slice} />,
  card_deck: ({ slice }) => <Slice allowEmpty alias='cardDeck' slice={slice} />,
  collection: ({ context, slice }) => {
    const { isSSR } = context
    return (
      <>
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <Collection slice={slice} />
          </React.Suspense>
        )}
      </>
    )
  },
  contact: ({ slice }) => <Slice allowEmpty alias='contact' slice={slice} />,
  counter: ({ slice }) => <Slice allowEmpty alias='counter' slice={slice} />,
  hero: ({ slice }) => <Slice allowEmpty alias='hero' slice={slice} />,
  image_gallery: ({ slice }) => <Slice allowEmpty alias='image' slice={slice} />,
  instagram_carousel: ({ slice }) => <Slice allowEmpty alias='instagram' slice={slice} />,
  internal_menu: ({ slice }) => <Slice allowEmpty alias='internalMenu' slice={slice} />,
  map: ({ slice }) => <Slice allowEmpty alias='map' slice={slice} />,
  partner_logos: ({ slice }) => <Slice allowEmpty alias='partners' slice={slice} />,
  posts: ({ slice }) => <Slice allowEmpty alias='posts' slice={slice} />,
  products: ({ slice }) => <Slice allowEmpty alias='products' slice={slice} />,
  quote: ({ slice }) => <Slice allowEmpty alias='quote' slice={slice} />,
  text: ({ slice }) => <Slice allowEmpty alias='text' slice={slice} />,
  video: ({ slice }) => <Slice allowEmpty alias='video' slice={slice} />,
  wholesale_contact: ({ slice }) => <Slice allowEmpty alias='wholesaleContact' slice={slice} />
}

const SliceList = ({ slices }) => {
  const isSSR = typeof window === 'undefined'
  return <SliceZone slices={slices} context={{ isSSR }} components={components} defaultComponent={() => null} />
}

export default SliceList
